import templateUrl from './taskHistoryComponent.html';

class TaskHistoryController {
  goBack() {
    this.historyMode = false;
  }
}

export default {
  templateUrl,
  controller: TaskHistoryController,
  controllerAs: 'ctrl',
  bindings: {
    dismiss: '&',
    historyMode: '=',
    history: '<',
  },
};
